import { AlertIcon } from "../icons/PestIcons";
import type { ResultType } from "../../constants";

interface TerminationScreenProps {
  type: ResultType;
  city?: string;
  pestLabels?: string[];
}

function getContent(type: ResultType, city?: string, pestLabels?: string[]) {
  switch (type) {
    case "commercial":
      return {
        title: "Commercial Assessment Required",
        body: "Commercial facility estimates require a manual assessment by a licensed estimator. Automated dispatch routing is not available for commercial properties at this time. Please contact a commercial pest management provider directly.",
      };
    case "invalid_zip":
      return {
        title: "No Local Labor Rate Data Available",
        body: "The diagnostic engine does not have regional labor rate data or pest activity records for the ZIP code entered. Estimates cannot be generated without localized pricing inputs.",
      };
    case "specialty_license":
      return {
        title: "Specialty License Required",
        body: `Treatment for ${pestLabels?.join(", ") ?? "the selected pest type"} requires a specialty license not supported on the main network. Local specialists with the required credentials must be contacted through alternative channels.`,
      };
    default:
      return {
        title: "Unable to Generate Report",
        body: "The estimation engine could not process your inputs. Please verify your data and try again.",
      };
  }
}

export function TerminationScreen({ type, city, pestLabels }: TerminationScreenProps) {
  const { title, body } = getContent(type, city, pestLabels);

  return (
    <div className="animate-fade-in p-4 text-center sm:p-5">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
        <AlertIcon className="h-8 w-8 text-slate-400" />
      </div>
      <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Process Terminated</p>
      <h2 className="mt-1 text-base font-semibold text-slate-900">{title}</h2>
      <p className="mx-auto mt-3 max-w-sm text-xs leading-relaxed text-slate-500">{body}</p>
      {city && type === "invalid_zip" && (
        <p className="mt-2 font-mono text-[10px] text-slate-400">Region: {city}</p>
      )}
    </div>
  );
}
